const SYMBOL_OPTIONS = [
  { v: "BTC", l: "BTC · Bitcoin" },
  { v: "ETH", l: "ETH · Ethereum" },
  { v: "SOL", l: "SOL · Solana" },
  { v: "AAPL", l: "AAPL · Apple" },
  { v: "NVDA", l: "NVDA · Nvidia" },
  { v: "TSLA", l: "TSLA · Tesla" },
  { v: "GOLD", l: "GOLD · Bullion" },
  { v: "SILVER", l: "SILVER · Bullion" },
  { v: "EURUSD", l: "EUR / USD" },
  { v: "USDJPY", l: "USD / JPY" },
];

export default function FeaturedSymbolSwitcher({ value, onChange }) {
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="featured-symbol-switcher">
      <span className="text-[10px] uppercase tracking-[0.28em] text-white/40">Watching</span>
      <select
        data-testid="featured-symbol-select"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="border border-white/15 bg-ink px-3 py-1.5 font-tabular text-xs tracking-wide text-white focus:border-gold focus:outline-none"
      >
        {SYMBOL_OPTIONS.map((o) => (
          <option key={o.v} value={o.v}>{o.l}</option>
        ))}
      </select>
    </div>
  );
}

export { SYMBOL_OPTIONS };
